import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./style.css";

const ConfirmModal = (props) => {
  const { submitForm } = props;
  const [show, setShow] = useState(false);
  const [Edit, setEdit] = useState(0);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const saveData = () => {
    handleClose();
    submitForm();
  }

  return (
    <>
      <Button onClick={handleShow} className={`btns btn m-0 ${props.type}`}>
        {props.button}
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="d-flex font-weight-bold">{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fw-bold text-center pb-4">
            {props.content}
          </p>
        </Modal.Body>
        <div className="row bottom-btn mb-4 justify-content-between mx-0 px-4">
          <div className="col-lg-6">
            <div className="d-grid gap-2">
              <button
                className="btn btns btn-left"
                type="button"
                data-bs-dismiss="modal"
                onClick={handleClose}
              >
                {props.cancel}
              </button>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-grid gap-2">
              <button
                className="btn btns btn-right"
                type="button"
                data-bs-dismiss="modal"
                onClick={saveData}
              >
                {props.confirm}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmModal;